/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListWorksheetBlocksParams,
  ListWorksheetResponsesParams,
  MoveWorksheetBlockInput,
  SchemaValidationErrorResponse,
  ValidationError,
  Worksheet,
  WorksheetAiGenerationInput,
  WorksheetAnswerOption,
  WorksheetAnswerOptionInput,
  WorksheetBlock,
  WorksheetBlockInput,
  WorksheetBlockSolution,
  WorksheetBlockSolutionInput,
  WorksheetBlocks,
  WorksheetInput,
  WorksheetResponse,
  WorksheetResponseFeedback,
  WorksheetResponseFeedbackRequestInput,
  WorksheetResponseInput,
  WorksheetResponses
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Delete Answer Option
 */
export const destroyWorksheetAnswerOption = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/worksheet/answer_options/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWorksheetAnswerOptionMutationKey = () => ['destroyWorksheetAnswerOption'] as const;

export const getDestroyWorksheetAnswerOptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>, TError,DestroyWorksheetAnswerOptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>, TError,DestroyWorksheetAnswerOptionMutationVariables, TContext> => {

const mutationKey = getDestroyWorksheetAnswerOptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>, DestroyWorksheetAnswerOptionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyWorksheetAnswerOption(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWorksheetAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>>

    export type DestroyWorksheetAnswerOptionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DestroyWorksheetAnswerOptionMutationVariables = {id: string}

    /**
 * @summary Delete Answer Option
 */
export const useDestroyWorksheetAnswerOption = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>, TError,DestroyWorksheetAnswerOptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWorksheetAnswerOption>>,
        TError,
        DestroyWorksheetAnswerOptionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyWorksheetAnswerOptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Answer Option
 */
export const updateWorksheetAnswerOption = (
    id: MaybeRefOrGetter<string>,
    worksheetAnswerOptionInput?: MaybeRefOrGetter<WorksheetAnswerOptionInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetAnswerOptionInput = toValue(worksheetAnswerOptionInput);

      return axiosClient<WorksheetAnswerOption>(
      {url: `/worksheet/answer_options/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetAnswerOptionInput, signal
    },
      );
    }




export const getUpdateWorksheetAnswerOptionMutationKey = () => ['updateWorksheetAnswerOption'] as const;

export const getUpdateWorksheetAnswerOptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetAnswerOption>>, TError,UpdateWorksheetAnswerOptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetAnswerOption>>, TError,UpdateWorksheetAnswerOptionMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetAnswerOptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetAnswerOption>>, UpdateWorksheetAnswerOptionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetAnswerOption(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetAnswerOption>>>
    export type UpdateWorksheetAnswerOptionMutationBody = WorksheetAnswerOptionInput | undefined
    export type UpdateWorksheetAnswerOptionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateWorksheetAnswerOptionMutationVariables = {id: string;data?: WorksheetAnswerOptionInput}

    /**
 * @summary Update Answer Option
 */
export const useUpdateWorksheetAnswerOption = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetAnswerOption>>, TError,UpdateWorksheetAnswerOptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetAnswerOption>>,
        TError,
        UpdateWorksheetAnswerOptionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetAnswerOptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Answer Option
 */
export const createWorksheetAnswerOption = (
    blockId: MaybeRefOrGetter<string>,
    worksheetAnswerOptionInput?: MaybeRefOrGetter<WorksheetAnswerOptionInput>,
 signal?: AbortSignal
) => {
      blockId = toValue(blockId);
worksheetAnswerOptionInput = toValue(worksheetAnswerOptionInput);

      return axiosClient<WorksheetAnswerOption>(
      {url: `/worksheet/blocks/${blockId}/answer_options`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetAnswerOptionInput, signal
    },
      );
    }




export const getCreateWorksheetAnswerOptionMutationKey = () => ['createWorksheetAnswerOption'] as const;

export const getCreateWorksheetAnswerOptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetAnswerOption>>, TError,CreateWorksheetAnswerOptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetAnswerOption>>, TError,CreateWorksheetAnswerOptionMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetAnswerOptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetAnswerOption>>, CreateWorksheetAnswerOptionMutationVariables> = (props) => {
          const {blockId,data} = props ?? {};

          return  createWorksheetAnswerOption(blockId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetAnswerOption>>>
    export type CreateWorksheetAnswerOptionMutationBody = WorksheetAnswerOptionInput | undefined
    export type CreateWorksheetAnswerOptionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateWorksheetAnswerOptionMutationVariables = {blockId: string;data?: WorksheetAnswerOptionInput}

    /**
 * @summary Create Answer Option
 */
export const useCreateWorksheetAnswerOption = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetAnswerOption>>, TError,CreateWorksheetAnswerOptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetAnswerOption>>,
        TError,
        CreateWorksheetAnswerOptionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetAnswerOptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Solution
 */
export const createWorksheetSolution = (
    blockId: MaybeRefOrGetter<string>,
    worksheetBlockSolutionInput?: MaybeRefOrGetter<WorksheetBlockSolutionInput>,
 signal?: AbortSignal
) => {
      blockId = toValue(blockId);
worksheetBlockSolutionInput = toValue(worksheetBlockSolutionInput);

      return axiosClient<WorksheetBlockSolution>(
      {url: `/worksheet/blocks/${blockId}/solutions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetBlockSolutionInput, signal
    },
      );
    }




export const getCreateWorksheetSolutionMutationKey = () => ['createWorksheetSolution'] as const;

export const getCreateWorksheetSolutionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetSolution>>, TError,CreateWorksheetSolutionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetSolution>>, TError,CreateWorksheetSolutionMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetSolutionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetSolution>>, CreateWorksheetSolutionMutationVariables> = (props) => {
          const {blockId,data} = props ?? {};

          return  createWorksheetSolution(blockId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetSolution>>>
    export type CreateWorksheetSolutionMutationBody = WorksheetBlockSolutionInput | undefined
    export type CreateWorksheetSolutionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateWorksheetSolutionMutationVariables = {blockId: string;data?: WorksheetBlockSolutionInput}

    /**
 * @summary Create Solution
 */
export const useCreateWorksheetSolution = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetSolution>>, TError,CreateWorksheetSolutionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetSolution>>,
        TError,
        CreateWorksheetSolutionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetSolutionMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Block
 */
export const destroyWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/worksheet/blocks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWorksheetBlockMutationKey = () => ['destroyWorksheetBlock'] as const;

export const getDestroyWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetBlock>>, TError,DestroyWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetBlock>>, TError,DestroyWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getDestroyWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWorksheetBlock>>, DestroyWorksheetBlockMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyWorksheetBlock(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWorksheetBlock>>>

    export type DestroyWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DestroyWorksheetBlockMutationVariables = {id: string}

    /**
 * @summary Delete Block
 */
export const useDestroyWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetBlock>>, TError,DestroyWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWorksheetBlock>>,
        TError,
        DestroyWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Block
 */
export const showWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<WorksheetBlock>(
      {url: `/worksheet/blocks/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowWorksheetBlockQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'worksheet','blocks',id
    ] as const;
    }


export const getShowWorksheetBlockQueryOptions = <TData = Awaited<ReturnType<typeof showWorksheetBlock>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetBlock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowWorksheetBlockQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showWorksheetBlock>>> = ({ signal }) => showWorksheetBlock(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showWorksheetBlock>>, TError, TData>
}

export type ShowWorksheetBlockQueryResult = NonNullable<Awaited<ReturnType<typeof showWorksheetBlock>>>
export type ShowWorksheetBlockQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Block
 */

export function useShowWorksheetBlock<TData = Awaited<ReturnType<typeof showWorksheetBlock>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetBlock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowWorksheetBlockQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Block
 */
export const updateWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
    worksheetBlockInput?: MaybeRefOrGetter<WorksheetBlockInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetBlockInput = toValue(worksheetBlockInput);

      return axiosClient<WorksheetBlock>(
      {url: `/worksheet/blocks/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetBlockInput, signal
    },
      );
    }




export const getUpdateWorksheetBlockMutationKey = () => ['updateWorksheetBlock'] as const;

export const getUpdateWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,UpdateWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,UpdateWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetBlock>>, UpdateWorksheetBlockMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetBlock(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetBlock>>>
    export type UpdateWorksheetBlockMutationBody = WorksheetBlockInput | undefined
    export type UpdateWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateWorksheetBlockMutationVariables = {id: string;data?: WorksheetBlockInput}

    /**
 * @summary Update Block
 */
export const useUpdateWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,UpdateWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetBlock>>,
        TError,
        UpdateWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Generate AI content for a worksheet block
 */
export const aiGenerateWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
    worksheetAiGenerationInput?: MaybeRefOrGetter<WorksheetAiGenerationInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetAiGenerationInput = toValue(worksheetAiGenerationInput);

      return axiosClient<void>(
      {url: `/worksheet/blocks/${id}/ai_generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetAiGenerationInput, signal
    },
      );
    }




export const getAiGenerateWorksheetBlockMutationKey = () => ['aiGenerateWorksheetBlock'] as const;

export const getAiGenerateWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>, TError,AiGenerateWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>, TError,AiGenerateWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getAiGenerateWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>, AiGenerateWorksheetBlockMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiGenerateWorksheetBlock(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiGenerateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>>
    export type AiGenerateWorksheetBlockMutationBody = WorksheetAiGenerationInput | undefined
    export type AiGenerateWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type AiGenerateWorksheetBlockMutationVariables = {id: string;data?: WorksheetAiGenerationInput}

    /**
 * @summary Generate AI content for a worksheet block
 */
export const useAiGenerateWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>, TError,AiGenerateWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof aiGenerateWorksheetBlock>>,
        TError,
        AiGenerateWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getAiGenerateWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive Block
 */
export const archiveWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/worksheet/blocks/${id}/archive`, method: 'PATCH', signal
    },
      );
    }




export const getArchiveWorksheetBlockMutationKey = () => ['archiveWorksheetBlock'] as const;

export const getArchiveWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,ArchiveWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,ArchiveWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getArchiveWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveWorksheetBlock>>, ArchiveWorksheetBlockMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveWorksheetBlock(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof archiveWorksheetBlock>>>

    export type ArchiveWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ArchiveWorksheetBlockMutationVariables = {id: string}

    /**
 * @summary Archive Block
 */
export const useArchiveWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,ArchiveWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveWorksheetBlock>>,
        TError,
        ArchiveWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Duplicate Block
 */
export const duplicateWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<WorksheetBlock>(
      {url: `/worksheet/blocks/${id}/duplicate`, method: 'POST', signal
    },
      );
    }




export const getDuplicateWorksheetBlockMutationKey = () => ['duplicateWorksheetBlock'] as const;

export const getDuplicateWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateWorksheetBlock>>, TError,DuplicateWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateWorksheetBlock>>, TError,DuplicateWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getDuplicateWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateWorksheetBlock>>, DuplicateWorksheetBlockMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  duplicateWorksheetBlock(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateWorksheetBlock>>>

    export type DuplicateWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DuplicateWorksheetBlockMutationVariables = {id: string}

    /**
 * @summary Duplicate Block
 */
export const useDuplicateWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateWorksheetBlock>>, TError,DuplicateWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateWorksheetBlock>>,
        TError,
        DuplicateWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Block
 */
export const moveWorksheetBlock = (
    id: MaybeRefOrGetter<string>,
    moveWorksheetBlockInput?: MaybeRefOrGetter<MoveWorksheetBlockInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
moveWorksheetBlockInput = toValue(moveWorksheetBlockInput);

      return axiosClient<WorksheetBlock>(
      {url: `/worksheet/blocks/${id}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveWorksheetBlockInput, signal
    },
      );
    }




export const getMoveWorksheetBlockMutationKey = () => ['moveWorksheetBlock'] as const;

export const getMoveWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,MoveWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,MoveWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getMoveWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveWorksheetBlock>>, MoveWorksheetBlockMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  moveWorksheetBlock(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof moveWorksheetBlock>>>
    export type MoveWorksheetBlockMutationBody = MoveWorksheetBlockInput | undefined
    export type MoveWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MoveWorksheetBlockMutationVariables = {id: string;data?: MoveWorksheetBlockInput}

    /**
 * @summary Move Block
 */
export const useMoveWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,MoveWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveWorksheetBlock>>,
        TError,
        MoveWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getMoveWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Response
 */
export const destroyWorksheetResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/worksheet/responses/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWorksheetResponseMutationKey = () => ['destroyWorksheetResponse'] as const;

export const getDestroyWorksheetResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetResponse>>, TError,DestroyWorksheetResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetResponse>>, TError,DestroyWorksheetResponseMutationVariables, TContext> => {

const mutationKey = getDestroyWorksheetResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWorksheetResponse>>, DestroyWorksheetResponseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyWorksheetResponse(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWorksheetResponse>>>

    export type DestroyWorksheetResponseMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DestroyWorksheetResponseMutationVariables = {id: string}

    /**
 * @summary Delete Response
 */
export const useDestroyWorksheetResponse = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetResponse>>, TError,DestroyWorksheetResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWorksheetResponse>>,
        TError,
        DestroyWorksheetResponseMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyWorksheetResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Response
 */
export const showWorksheetResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<WorksheetResponse>(
      {url: `/worksheet/responses/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowWorksheetResponseQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'worksheet','responses',id
    ] as const;
    }


export const getShowWorksheetResponseQueryOptions = <TData = Awaited<ReturnType<typeof showWorksheetResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowWorksheetResponseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showWorksheetResponse>>> = ({ signal }) => showWorksheetResponse(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showWorksheetResponse>>, TError, TData>
}

export type ShowWorksheetResponseQueryResult = NonNullable<Awaited<ReturnType<typeof showWorksheetResponse>>>
export type ShowWorksheetResponseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Response
 */

export function useShowWorksheetResponse<TData = Awaited<ReturnType<typeof showWorksheetResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetResponse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowWorksheetResponseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Response
 */
export const updateWorksheetResponse = (
    id: MaybeRefOrGetter<string>,
    worksheetResponseInput?: MaybeRefOrGetter<WorksheetResponseInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetResponseInput = toValue(worksheetResponseInput);

      return axiosClient<WorksheetResponse>(
      {url: `/worksheet/responses/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetResponseInput, signal
    },
      );
    }




export const getUpdateWorksheetResponseMutationKey = () => ['updateWorksheetResponse'] as const;

export const getUpdateWorksheetResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetResponse>>, TError,UpdateWorksheetResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetResponse>>, TError,UpdateWorksheetResponseMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetResponse>>, UpdateWorksheetResponseMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetResponse(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetResponse>>>
    export type UpdateWorksheetResponseMutationBody = WorksheetResponseInput | undefined
    export type UpdateWorksheetResponseMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateWorksheetResponseMutationVariables = {id: string;data?: WorksheetResponseInput}

    /**
 * @summary Update Response
 */
export const useUpdateWorksheetResponse = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetResponse>>, TError,UpdateWorksheetResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetResponse>>,
        TError,
        UpdateWorksheetResponseMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary Submit Response
 */
export const submitWorksheetResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<WorksheetResponse>(
      {url: `/worksheet/responses/${id}/submit`, method: 'POST', signal
    },
      );
    }




export const getSubmitWorksheetResponseMutationKey = () => ['submitWorksheetResponse'] as const;

export const getSubmitWorksheetResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWorksheetResponse>>, TError,SubmitWorksheetResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitWorksheetResponse>>, TError,SubmitWorksheetResponseMutationVariables, TContext> => {

const mutationKey = getSubmitWorksheetResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitWorksheetResponse>>, SubmitWorksheetResponseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  submitWorksheetResponse(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof submitWorksheetResponse>>>

    export type SubmitWorksheetResponseMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type SubmitWorksheetResponseMutationVariables = {id: string}

    /**
 * @summary Submit Response
 */
export const useSubmitWorksheetResponse = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWorksheetResponse>>, TError,SubmitWorksheetResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof submitWorksheetResponse>>,
        TError,
        SubmitWorksheetResponseMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitWorksheetResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Feedback
 */
export const createWorksheetFeedback = (
    responseId: MaybeRefOrGetter<string>,
    worksheetResponseFeedbackRequestInput?: MaybeRefOrGetter<WorksheetResponseFeedbackRequestInput>,
 signal?: AbortSignal
) => {
      responseId = toValue(responseId);
worksheetResponseFeedbackRequestInput = toValue(worksheetResponseFeedbackRequestInput);

      return axiosClient<WorksheetResponseFeedback>(
      {url: `/worksheet/responses/${responseId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetResponseFeedbackRequestInput, signal
    },
      );
    }




export const getCreateWorksheetFeedbackMutationKey = () => ['createWorksheetFeedback'] as const;

export const getCreateWorksheetFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,CreateWorksheetFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,CreateWorksheetFeedbackMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetFeedback>>, CreateWorksheetFeedbackMutationVariables> = (props) => {
          const {responseId,data} = props ?? {};

          return  createWorksheetFeedback(responseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetFeedback>>>
    export type CreateWorksheetFeedbackMutationBody = WorksheetResponseFeedbackRequestInput | undefined
    export type CreateWorksheetFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateWorksheetFeedbackMutationVariables = {responseId: string;data?: WorksheetResponseFeedbackRequestInput}

    /**
 * @summary Create Feedback
 */
export const useCreateWorksheetFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,CreateWorksheetFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetFeedback>>,
        TError,
        CreateWorksheetFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Feedback
 */
export const destroyWorksheetFeedback = (
    responseId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      responseId = toValue(responseId);

      return axiosClient<void>(
      {url: `/worksheet/responses/${responseId}/feedback`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWorksheetFeedbackMutationKey = () => ['destroyWorksheetFeedback'] as const;

export const getDestroyWorksheetFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetFeedback>>, TError,DestroyWorksheetFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetFeedback>>, TError,DestroyWorksheetFeedbackMutationVariables, TContext> => {

const mutationKey = getDestroyWorksheetFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWorksheetFeedback>>, DestroyWorksheetFeedbackMutationVariables> = (props) => {
          const {responseId} = props ?? {};

          return  destroyWorksheetFeedback(responseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWorksheetFeedback>>>

    export type DestroyWorksheetFeedbackMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DestroyWorksheetFeedbackMutationVariables = {responseId: string}

    /**
 * @summary Delete Feedback
 */
export const useDestroyWorksheetFeedback = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetFeedback>>, TError,DestroyWorksheetFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWorksheetFeedback>>,
        TError,
        DestroyWorksheetFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyWorksheetFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Feedback
 */
export const showWorksheetFeedback = (
    responseId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      responseId = toValue(responseId);

      return axiosClient<WorksheetResponseFeedback>(
      {url: `/worksheet/responses/${responseId}/feedback`, method: 'GET', signal
    },
      );
    }




export const getShowWorksheetFeedbackQueryKey = (responseId: MaybeRefOrGetter<string>,) => {
    return [
    'worksheet','responses',responseId,'feedback'
    ] as const;
    }


export const getShowWorksheetFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof showWorksheetFeedback>>, TError = ErrorType<SchemaValidationErrorResponse>>(responseId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowWorksheetFeedbackQueryKey(responseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showWorksheetFeedback>>> = ({ signal }) => showWorksheetFeedback(responseId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(responseId) !== null && toValue(responseId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showWorksheetFeedback>>, TError, TData>
}

export type ShowWorksheetFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof showWorksheetFeedback>>>
export type ShowWorksheetFeedbackQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Show Feedback
 */

export function useShowWorksheetFeedback<TData = Awaited<ReturnType<typeof showWorksheetFeedback>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 responseId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetFeedback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowWorksheetFeedbackQueryOptions(responseId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Feedback
 */
export const updateWorksheetFeedback = (
    responseId: MaybeRefOrGetter<string>,
    worksheetResponseFeedbackRequestInput?: MaybeRefOrGetter<WorksheetResponseFeedbackRequestInput>,
 signal?: AbortSignal
) => {
      responseId = toValue(responseId);
worksheetResponseFeedbackRequestInput = toValue(worksheetResponseFeedbackRequestInput);

      return axiosClient<WorksheetResponseFeedback>(
      {url: `/worksheet/responses/${responseId}/feedback`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetResponseFeedbackRequestInput, signal
    },
      );
    }




export const getUpdateWorksheetFeedbackMutationKey = () => ['updateWorksheetFeedback'] as const;

export const getUpdateWorksheetFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,UpdateWorksheetFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,UpdateWorksheetFeedbackMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetFeedback>>, UpdateWorksheetFeedbackMutationVariables> = (props) => {
          const {responseId,data} = props ?? {};

          return  updateWorksheetFeedback(responseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetFeedback>>>
    export type UpdateWorksheetFeedbackMutationBody = WorksheetResponseFeedbackRequestInput | undefined
    export type UpdateWorksheetFeedbackMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateWorksheetFeedbackMutationVariables = {responseId: string;data?: WorksheetResponseFeedbackRequestInput}

    /**
 * @summary Update Feedback
 */
export const useUpdateWorksheetFeedback = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,UpdateWorksheetFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetFeedback>>,
        TError,
        UpdateWorksheetFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Solution
 */
export const destroyWorksheetSolution = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/worksheet/solutions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWorksheetSolutionMutationKey = () => ['destroyWorksheetSolution'] as const;

export const getDestroyWorksheetSolutionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetSolution>>, TError,DestroyWorksheetSolutionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetSolution>>, TError,DestroyWorksheetSolutionMutationVariables, TContext> => {

const mutationKey = getDestroyWorksheetSolutionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWorksheetSolution>>, DestroyWorksheetSolutionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyWorksheetSolution(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWorksheetSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWorksheetSolution>>>

    export type DestroyWorksheetSolutionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DestroyWorksheetSolutionMutationVariables = {id: string}

    /**
 * @summary Delete Solution
 */
export const useDestroyWorksheetSolution = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWorksheetSolution>>, TError,DestroyWorksheetSolutionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWorksheetSolution>>,
        TError,
        DestroyWorksheetSolutionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyWorksheetSolutionMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Solution
 */
export const updateWorksheetSolution = (
    id: MaybeRefOrGetter<string>,
    worksheetBlockSolutionInput?: MaybeRefOrGetter<WorksheetBlockSolutionInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetBlockSolutionInput = toValue(worksheetBlockSolutionInput);

      return axiosClient<WorksheetBlockSolution>(
      {url: `/worksheet/solutions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetBlockSolutionInput, signal
    },
      );
    }




export const getUpdateWorksheetSolutionMutationKey = () => ['updateWorksheetSolution'] as const;

export const getUpdateWorksheetSolutionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetSolution>>, TError,UpdateWorksheetSolutionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetSolution>>, TError,UpdateWorksheetSolutionMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetSolutionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetSolution>>, UpdateWorksheetSolutionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetSolution(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetSolution>>>
    export type UpdateWorksheetSolutionMutationBody = WorksheetBlockSolutionInput | undefined
    export type UpdateWorksheetSolutionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateWorksheetSolutionMutationVariables = {id: string;data?: WorksheetBlockSolutionInput}

    /**
 * @summary Update Solution
 */
export const useUpdateWorksheetSolution = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetSolution>>, TError,UpdateWorksheetSolutionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetSolution>>,
        TError,
        UpdateWorksheetSolutionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetSolutionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Worksheet
 */
export const createWorksheetWorksheet = (
    worksheetInput?: MaybeRefOrGetter<WorksheetInput>,
 signal?: AbortSignal
) => {
      worksheetInput = toValue(worksheetInput);

      return axiosClient<Worksheet>(
      {url: `/worksheet/worksheets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetInput, signal
    },
      );
    }




export const getCreateWorksheetWorksheetMutationKey = () => ['createWorksheetWorksheet'] as const;

export const getCreateWorksheetWorksheetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetWorksheet>>, TError,CreateWorksheetWorksheetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetWorksheet>>, TError,CreateWorksheetWorksheetMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetWorksheetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetWorksheet>>, CreateWorksheetWorksheetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorksheetWorksheet(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetWorksheetMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetWorksheet>>>
    export type CreateWorksheetWorksheetMutationBody = WorksheetInput | undefined
    export type CreateWorksheetWorksheetMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateWorksheetWorksheetMutationVariables = {data?: WorksheetInput}

    /**
 * @summary Create Worksheet
 */
export const useCreateWorksheetWorksheet = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetWorksheet>>, TError,CreateWorksheetWorksheetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetWorksheet>>,
        TError,
        CreateWorksheetWorksheetMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetWorksheetMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Worksheet
 */
export const showWorksheetWorksheet = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Worksheet>(
      {url: `/worksheet/worksheets/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowWorksheetWorksheetQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'worksheet','worksheets',id
    ] as const;
    }


export const getShowWorksheetWorksheetQueryOptions = <TData = Awaited<ReturnType<typeof showWorksheetWorksheet>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetWorksheet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowWorksheetWorksheetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showWorksheetWorksheet>>> = ({ signal }) => showWorksheetWorksheet(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showWorksheetWorksheet>>, TError, TData>
}

export type ShowWorksheetWorksheetQueryResult = NonNullable<Awaited<ReturnType<typeof showWorksheetWorksheet>>>
export type ShowWorksheetWorksheetQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Worksheet
 */

export function useShowWorksheetWorksheet<TData = Awaited<ReturnType<typeof showWorksheetWorksheet>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showWorksheetWorksheet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowWorksheetWorksheetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Worksheet
 */
export const updateWorksheetWorksheet = (
    id: MaybeRefOrGetter<string>,
    worksheetInput?: MaybeRefOrGetter<WorksheetInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
worksheetInput = toValue(worksheetInput);

      return axiosClient<Worksheet>(
      {url: `/worksheet/worksheets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: worksheetInput, signal
    },
      );
    }




export const getUpdateWorksheetWorksheetMutationKey = () => ['updateWorksheetWorksheet'] as const;

export const getUpdateWorksheetWorksheetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetWorksheet>>, TError,UpdateWorksheetWorksheetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetWorksheet>>, TError,UpdateWorksheetWorksheetMutationVariables, TContext> => {

const mutationKey = getUpdateWorksheetWorksheetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetWorksheet>>, UpdateWorksheetWorksheetMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetWorksheet(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetWorksheetMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetWorksheet>>>
    export type UpdateWorksheetWorksheetMutationBody = WorksheetInput | undefined
    export type UpdateWorksheetWorksheetMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateWorksheetWorksheetMutationVariables = {id: string;data?: WorksheetInput}

    /**
 * @summary Update Worksheet
 */
export const useUpdateWorksheetWorksheet = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetWorksheet>>, TError,UpdateWorksheetWorksheetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetWorksheet>>,
        TError,
        UpdateWorksheetWorksheetMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorksheetWorksheetMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Block
 */
export const createWorksheetBlock = (
    worksheetId: MaybeRefOrGetter<string>,
    worksheetBlockInput?: MaybeRefOrGetter<WorksheetBlockInput>,
 signal?: AbortSignal
) => {
      worksheetId = toValue(worksheetId);
worksheetBlockInput = toValue(worksheetBlockInput);

      return axiosClient<WorksheetBlock>(
      {url: `/worksheet/worksheets/${worksheetId}/blocks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetBlockInput, signal
    },
      );
    }




export const getCreateWorksheetBlockMutationKey = () => ['createWorksheetBlock'] as const;

export const getCreateWorksheetBlockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,CreateWorksheetBlockMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,CreateWorksheetBlockMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetBlockMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetBlock>>, CreateWorksheetBlockMutationVariables> = (props) => {
          const {worksheetId,data} = props ?? {};

          return  createWorksheetBlock(worksheetId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetBlock>>>
    export type CreateWorksheetBlockMutationBody = WorksheetBlockInput | undefined
    export type CreateWorksheetBlockMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateWorksheetBlockMutationVariables = {worksheetId: string;data?: WorksheetBlockInput}

    /**
 * @summary Create Block
 */
export const useCreateWorksheetBlock = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,CreateWorksheetBlockMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetBlock>>,
        TError,
        CreateWorksheetBlockMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetBlockMutationOptions(options), queryClient);
    }
    /**
 * @summary List Blocks
 */
export const listWorksheetBlocks = (
    worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetBlocksParams>,
 signal?: AbortSignal
) => {
      worksheetId = toValue(worksheetId);
params = toValue(params);

      return axiosClient<WorksheetBlocks>(
      {url: `/worksheet/worksheets/${worksheetId}/blocks`, method: 'GET',
        params, signal
    },
      );
    }




export const getListWorksheetBlocksQueryKey = (worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetBlocksParams>,) => {
    return [
    'worksheet','worksheets',worksheetId,'blocks', ...(params ? [params] : [])
    ] as const;
    }


export const getListWorksheetBlocksQueryOptions = <TData = Awaited<ReturnType<typeof listWorksheetBlocks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetBlocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWorksheetBlocksQueryKey(worksheetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorksheetBlocks>>> = ({ signal }) => listWorksheetBlocks(worksheetId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(worksheetId) !== null && toValue(worksheetId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData>
}

export type ListWorksheetBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof listWorksheetBlocks>>>
export type ListWorksheetBlocksQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List Blocks
 */

export function useListWorksheetBlocks<TData = Awaited<ReturnType<typeof listWorksheetBlocks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetBlocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorksheetBlocksQueryOptions(worksheetId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Response
 */
export const createWorksheetResponse = (
    worksheetId: MaybeRefOrGetter<string>,
    worksheetResponseInput?: MaybeRefOrGetter<WorksheetResponseInput>,
 signal?: AbortSignal
) => {
      worksheetId = toValue(worksheetId);
worksheetResponseInput = toValue(worksheetResponseInput);

      return axiosClient<WorksheetResponse>(
      {url: `/worksheet/worksheets/${worksheetId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: worksheetResponseInput, signal
    },
      );
    }




export const getCreateWorksheetResponseMutationKey = () => ['createWorksheetResponse'] as const;

export const getCreateWorksheetResponseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,CreateWorksheetResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,CreateWorksheetResponseMutationVariables, TContext> => {

const mutationKey = getCreateWorksheetResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetResponse>>, CreateWorksheetResponseMutationVariables> = (props) => {
          const {worksheetId,data} = props ?? {};

          return  createWorksheetResponse(worksheetId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetResponse>>>
    export type CreateWorksheetResponseMutationBody = WorksheetResponseInput | undefined
    export type CreateWorksheetResponseMutationError = ErrorType<SchemaValidationErrorResponse>
    export type CreateWorksheetResponseMutationVariables = {worksheetId: string;data?: WorksheetResponseInput}

    /**
 * @summary Create Response
 */
export const useCreateWorksheetResponse = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,CreateWorksheetResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetResponse>>,
        TError,
        CreateWorksheetResponseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorksheetResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary List Responses
 */
export const listWorksheetResponses = (
    worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetResponsesParams>,
 signal?: AbortSignal
) => {
      worksheetId = toValue(worksheetId);
params = toValue(params);

      return axiosClient<WorksheetResponses>(
      {url: `/worksheet/worksheets/${worksheetId}/responses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListWorksheetResponsesQueryKey = (worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetResponsesParams>,) => {
    return [
    'worksheet','worksheets',worksheetId,'responses', ...(params ? [params] : [])
    ] as const;
    }


export const getListWorksheetResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listWorksheetResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWorksheetResponsesQueryKey(worksheetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorksheetResponses>>> = ({ signal }) => listWorksheetResponses(worksheetId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(worksheetId) !== null && toValue(worksheetId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData>
}

export type ListWorksheetResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorksheetResponses>>>
export type ListWorksheetResponsesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List Responses
 */

export function useListWorksheetResponses<TData = Awaited<ReturnType<typeof listWorksheetResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 worksheetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListWorksheetResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorksheetResponsesQueryOptions(worksheetId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






